
    <p-dialog header="Cancellation Details" [(visible)]="isVisible" [modal]="true" [styleClass]="'cancellation-details-modal'" [maximizable]="false"
        [resizable]="false" [closeOnEscape]="false" [blockScroll]="true" [breakpoints]="{'768px': '100vw'}" [style]="{width: '750px', height: '90vh'}" (onHide)="onClose()">

        <div class="cancellation-details-body modal-body">
            <div *ngIf="isLoading" class="text-center p-4">
                <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
            </div>

            <div *ngIf="!isLoading && cancellationDetails" class="details-container">
                <!-- Booking Summary Section -->
                <div class="details-section booking-summary-section" *ngIf="bookingData">
                    <div class="section-title">
                        <i class="pi pi-briefcase"></i>
                        Booking Summary
                    </div>

                    <div class="summary-grid">
                        <div class="summary-item">
                            <div class="item-label">Booking ID</div>
                            <div class="item-value">{{ bookingData?.id || '-' }}</div>
                        </div>

                        <div class="summary-item">
                            <div class="item-label">Client Name</div>
                            <div class="item-value">{{ bookingData?.clientName || '-' }}</div>
                        </div>

                        <div class="summary-item">
                            <div class="item-label">Unit Category</div>
                            <div class="item-value">{{ bookingData?.product || '-' }}</div>
                        </div>

                        <div class="summary-item">
                            <div class="item-label">Amount</div>
                            <div class="item-value">{{ bookingData?.amount || '-' }}</div>
                        </div>

                        <div class="summary-item">
                            <div class="item-label">Received Amount</div>
                            <div class="item-value">{{ bookingData?.recivedAmount || '-' }}</div>
                        </div>

                        <div class="summary-item">
                            <div class="item-label">Agent Name</div>
                            <div class="item-value">{{ bookingData?.sourceName || '-' }}</div>
                        </div>
                    </div>
                </div>

                <!-- Two Column Layout for Desktop, Single Column for Mobile -->
                <div class="details-grid">
                    <!-- Request Details Column -->
                    <div class="details-section request-section">
                        <div class="section-title">
                            <i class="pi pi-bell"></i>
                            Cancellation Request
                        </div>

                        <div class="detail-item">
                            <div class="item-label">Requested By</div>
                            <div class="item-value">
                                <i class="pi pi-user"></i>
                                {{ cancellationDetails?.requestedBy?.name || '-' }}
                            </div>
                        </div>

                        <div class="detail-item">
                            <div class="item-label">Requested On</div>
                            <div class="item-value">
                                <i class="pi pi-calendar"></i>
                                {{ cancellationDetails?.requestedOn | date:'dd-MMM-yyyy hh:mm a' }}
                            </div>
                        </div>

                        <div class="detail-item full-width">
                            <div class="item-label">Cancellation Reason</div>
                            <div class="item-value remark-box">
                                {{ cancellationDetails?.requestRemark || '-' }}
                            </div>
                        </div>

                        <div class="detail-item full-width" *ngIf="cancellationDetails?.documentId">
                            <div class="item-label">Document</div>
                            <div class="document-item">
                                <i class="pi pi-file"></i>
                                <span>Document Attached</span>
                                <button pButton type="button" label="View" icon="pi pi-eye"
                                    class="p-button-sm p-button-link" (click)="openDocumentPreview()"
                                    [disabled]="!cancellationDocument">
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Approval Details Column -->
                    <div class="details-section approval-section"
                        *ngIf="cancellationDetails?.isApproved !== null && cancellationDetails?.isApproved !== undefined">
                        <div class="section-header">
                            <div class="section-title">
                                <i class="pi pi-check-circle"></i>
                                {{ (cancellationDetails?.isApproved === true ? 'Approval' : 'Rejection') }} Details
                            </div>

                            <span class="status-badge" [ngClass]="getStatusClass()">
                                {{ getStatusText() }}
                            </span>
                        </div>

                        <div class="detail-item">
                            <div class="item-label">{{ (cancellationDetails?.isApproved === true ? 'Approved' :
                                'Rejected') }} By</div>
                            <div class="item-value">
                                <i class="pi pi-user"></i>
                                {{ cancellationDetails?.approvedRejectedBy?.name || '-' }}
                            </div>
                        </div>

                        <div class="detail-item">
                            <div class="item-label">{{ (cancellationDetails?.isApproved === true ? 'Approved' :
                                'Rejected') }} On</div>
                            <div class="item-value">
                                <i class="pi pi-calendar"></i>
                                {{ cancellationDetails?.approvedRejectedOn | date:'dd-MMM-yyyy hh:mm a' }}
                            </div>
                        </div>

                        <div class="detail-item full-width" *ngIf="cancellationDetails?.approverRemark">
                            <div class="item-label">{{ (cancellationDetails?.isApproved === true ? 'Approval' :
                                'Rejection') }} Remark</div>
                            <div class="item-value remark-box">
                                {{ cancellationDetails?.approverRemark }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="details-footer">
                    <button pButton type="button" label="Close" class="btn btn-secondary"
                        (click)="onClose()">
                    </button>
                </div>
            </div>
        </div>
    </p-dialog>

    <!-- Document Preview Modal -->
    <p-dialog header="Document Preview" [(visible)]="showDocumentPreview" [modal]="true" [styleClass]="'document-preview-modal'"
        [maximizable]="true" [resizable]="true" (onHide)="closePreview()"
        [breakpoints]="{'768px': '100vw'}" [style]="{ width: '80rem', 'max-height': '90vh' }">

        <div class="document-preview-body">
            <img *ngIf="cancellationDocument && cancellationDocument.mimeType?.includes('image')"
                [src]="'data:' + cancellationDocument.mimeType + ';base64,' + cancellationDocument.data"
                class="preview-image" alt="Full Document">
            <div *ngIf="cancellationDocument && cancellationDocument.mimeType?.includes('pdf')" class="pdf-viewer">
                PDF Document Preview Not Available
            </div>
        </div>
    </p-dialog>